import {css} from '@isceco/widget-library2/external/lit'

export default css`

  #submit-status {
    margin-bottom: var(--isceco-space-300);
  }

  .status {
    display: flex;
    margin-bottom: var(--isceco-space-300);
  }

  .details {
    margin-bottom: var(--isceco-space-300);
  }

  .hidden {
    display: none!important;
  }

  @media print {
    .noprint {
      display: none;
    }
  }
`
